__turbopack_context__.v({
  "closeButton": "_9CriNq_closeButton",
  "ctaButton": "_9CriNq_ctaButton",
  "header": "_9CriNq_header",
  "popup": "_9CriNq_popup",
  "text": "_9CriNq_text",
  "title": "_9CriNq_title",
});
